import type { MacroTotals } from './mealLogCore'

export const MACRO_SANITY_MAX_KCAL = 7000
export const MACRO_SANITY_MAX_PROTEIN_G = 450

export const MACRO_BASELINE_TEMPLATE: MacroTotals = {
  calories_kcal: 2400,
  protein_g: 180,
  carbs_g: 220,
  fat_g: 70,
}

export function isMacroPlanSane(totals: Pick<MacroTotals, 'calories_kcal' | 'protein_g'>): boolean {
  return (
    Number.isFinite(totals.calories_kcal) &&
    Number.isFinite(totals.protein_g) &&
    totals.calories_kcal > 0 &&
    totals.calories_kcal <= MACRO_SANITY_MAX_KCAL &&
    totals.protein_g >= 0 &&
    totals.protein_g <= MACRO_SANITY_MAX_PROTEIN_G
  )
}

export function sanitizeMacroPlan(totals: MacroTotals, context?: string): MacroTotals {
  if (isMacroPlanSane(totals)) return totals
  if (typeof console !== 'undefined') {
    console.warn('[macroSanity] impossible plan — using baseline template', context ?? '', totals)
  }
  return { ...MACRO_BASELINE_TEMPLATE }
}
